import { Mode } from "@/types/common";

function assertValue<T>(v: T | undefined, errorMessage: string): T {
  if (v === undefined) {
    throw new Error(errorMessage);
  }

  return v;
}

export const mode = assertValue(import.meta.env.MODE as Mode, "Missing environment variable: VITE_MODE");

export const mobileHost = assertValue(
  import.meta.env.VITE_MOBILE_HOST,
  "Missing environment variable: VITE_MOBILE_HOST"
);

export const appVersion = assertValue(
  import.meta.env.VITE_APP_VERSION,
  "Missing environment variable: VITE_APP_VERSION"
);

export const supabaseUrl = assertValue(
  import.meta.env.VITE_SUPABASE_URL,
  "Missing environment variable: VITE_SUPABASE_URL"
);

export const supabaseAnonKey = assertValue(
  import.meta.env.VITE_SUPABASE_ANON_KEY,
  "Missing environment variable: VITE_SUPABASE_ANON_KEY"
);

export const posthogKey = assertValue(
  import.meta.env.VITE_POSTHOG_KEY,
  "Missing environment variable: VITE_PUBLIC_POSTHOG_KEY"
);

export const posthogApiHost = assertValue(
  import.meta.env.VITE_POSTHOG_API_HOST,
  "Missing environment variable: VITE_PUBLIC_POSTHOG_HOST"
);

export const stripePublishableKey = assertValue(
  import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
  "Missing environment variable: VITE_STRIPE_PUBLISHABLE_KEY"
);

export const STRIPE_MONTHLY_PRICE_ID = assertValue(
  import.meta.env.VITE_STRIPE_MONTHLY_PRICE_ID,
  "Missing environment variable: VITE_STRIPE_MONTHLY_PRICE_ID"
);

export const STRIPE_YEARLY_PRICE_ID = assertValue(
  import.meta.env.VITE_STRIPE_YEARLY_PRICE_ID,
  "Missing environment variable: VITE_STRIPE_YEARLY_PRICE_ID"
);
